const changeEmailAddress = (state = null, action) => {
	switch (action.type) {
		case 'CHANGE_EMAIL_ADDRESS':
			return action.value;
		default:
			return state;
	}
};

export default changeEmailAddress;

export const action = {
	change: value => ({ type: 'CHANGE_EMAIL_ADDRESS', value }),
};
